import loadable from '@loadable/component';

export const DisplayPercentage = loadable(
  () => import(/* webpackChunkName: 'display-percentage' */ './DisplayPercentage'),
);
